'use client'
import React from 'react'
import './style.css';
import styles from './style.module.css';
import { formatMsg, Helper, timeutil } from '../../..';
import { AttendanceStatus } from '../../../types/attendance';
import { Tooltip } from 'antd';

function AttendanceMobileCard(props) {
    const { attendanceObj, participantsMap, packagesMap, centersMap, firebase, participantsAttendanceMap } = props;

    function getAbsentNote(displayAttendanceObj) {

        if (displayAttendanceObj?.absentNote) {
            const note = displayAttendanceObj.absentNote;

            return <div className="mobile-attendance-status-SubLabel">
                {note}
            </div>
        }

        return null;
    }

    function getCheckInCheckOutTime(attendance) {

        const checkInTs = attendance.latestCheckIn;
        const checkOutTs = attendance.latestCheckOut;

        if (!checkInTs && !checkOutTs) return null;

        const checkInTime = checkInTs
            ? timeutil.getInstance(attendance.latestCheckIn).format("hh:mm A")
            : formatMsg('small.pending');
        const checkOutTime = checkOutTs
            ? timeutil.getInstance(attendance.latestCheckOut).format("hh:mm A")
            : formatMsg('small.pending');


        const checkInLabel = `${attendance.lateIn ? formatMsg('lateIn') : formatMsg('capital.in')} ${checkInTime}`;
        const checkOutLabel = `${attendance.lateOut ? formatMsg('lateOut') : formatMsg('out')} ${checkOutTime}`;

        return (
            <div className="mobile-attendance-status-SubLabel-container">
                <div className="mobile-attendance-status-SubLabel" style={{ color: attendance.lateIn ? "#E56C32" : checkInTime === formatMsg('small.pending') ? "#FC7F03" : "#00855A" }}>
                    {checkInLabel}
                </div>
                <div className="mobile-attendance-status-SubLabel" style={{ color: attendance.lateOut ? "#E56C32" : checkOutTime === formatMsg('small.pending') ? "#FC7F03" : "#00855A" }}>
                    {checkOutLabel}
                </div>
            </div>
        )
    }

    const getAttendanceStatus = () => {

        const dateSlotCenterEntityKey = `${timeutil.inFormat(attendanceObj.date, 'DD-MM-YY')}--${attendanceObj.slotRandomId}--${attendanceObj.centerId}--${attendanceObj.profileId}`;
        const displayAttendanceObj = participantsAttendanceMap.get(dateSlotCenterEntityKey);
        const attendanceStatus: AttendanceStatus = Helper.getAttendanceStatus(displayAttendanceObj);
        return (
            <div className="mobile-attendance-Header">
                {(attendanceStatus === 'CLEARED' || attendanceStatus === 'PENDING') && (
                    <div className="mobile-attendance-Header">
                        <div className="mobile-attn-actions-img-container">
                            <img
                                className="mobile-attn-actions-img"
                                src='/images/yellowExclaimation.png'
                            />
                        </div>
                        <div className='mobile-attendance-status-SubLabel'>{formatMsg("pending")}</div>
                    </div>
                )}
                {attendanceStatus === "ABSENT" && (
                    <div className="mobile-attendance-Header">
                        <div className="mobile-attn-actions-img-container">
                            <img
                                className="mobile-attn-actions-img"
                                src='/images/absent.png'
                            />
                        </div>
                        {getAbsentNote(displayAttendanceObj)}
                    </div>
                )}
                {attendanceStatus === "PRESENT" && (
                    <div className="mobile-attendance-Header">
                        <div className="mobile-attn-actions-img-container">
                            <img
                                className="mobile-attn-actions-img"
                                src='/images/present.png'
                            />
                        </div>
                        {
                            getCheckInCheckOutTime(displayAttendanceObj)
                        }
                    </div>
                )}
            </div>
        );
    }
    return (
        <div className='attendance-list-card'>
            <div className='attendance-card-1st-row'>
                <div className='attendance-card-1st-row-col'>
                    <div className='attendance-basic-detail-container'>
                        <div className='attendance-profile-name'>
                            {(participantsMap.get(attendanceObj.profileId) || {}).name}
                        </div>
                        <div className='attendance-user-img-container'>
                            <img
                                src='/images/user.png'
                                className='attendance-user-img'
                            />
                        </div>
                        <div className='attendance-user-name'>
                            {firebase.user.name}
                        </div>
                    </div>
                    <div className='mobile-attendance-raise-date'>
                        <div className='attendance-calendar-img-container'>
                            <img
                                src='/images/calender_mobile.png'
                                className='attendance-calendar-img'
                            />
                        </div>
                        {timeutil.getInstance(attendanceObj.date).format(Helper.dateFormat(firebase))}
                        <span className="mobile-dot" />
                        {timeutil.getInstance(attendanceObj.startTime).format("hh:mm A")} - {timeutil.getInstance(attendanceObj.endTime).format("hh:mm A")}
                    </div>
                </div>

                <div className='attendance-status'>
                    {getAttendanceStatus()}
                </div>
            </div>
            <div className='mobile-attendance-horizontal-divider' />

            <div className='attendance-2nd-row-1st-col'>
                <div className='mobile-attendance-pkg-container'>
                    <div className='mobile-attendance-pkgName-header'>
                        {(packagesMap.get(attendanceObj.packageId) || {}).name}
                    </div>
                    <div className='mobile-attendance-batchName'>
                        {attendanceObj.batchName}
                    </div>
                </div>
                <div className='mobile-attendance-vertical-divider' />
                <div className='mobile-attendance-center-container' >
                    <div className='mobile-attendance-pkgName-header'>
                        {(centersMap.get(attendanceObj.centerId) || {}).name}
                    </div>
                    <div className='mobile-attendance-batchName'>
                        {timeutil.getInstance(attendanceObj.startTime).format("hh:mm A")} - {timeutil.getInstance(attendanceObj.endTime).format("hh:mm A")}
                    </div>
                </div>
            </div>

        </div>
    )
}

export default AttendanceMobileCard
